import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import {
  unsubscribeFromTipjar,
  unsubscribeFromPrimo,
} from "../../../../api/users";
import { Spinner } from "react-bootstrap";
import { log_error } from "../../../../api";

export default ({ show, hide, showSubscribtionModal }) => {
  const { current_user } = useSelector((state) => state);

  let [loading, setLoading] = useState(false);

  const handleUnsubscribe = async () => {
    try {
      setLoading(true);
      current_user.is_subscribed_to_primo
        ? await unsubscribeFromPrimo()
        : await unsubscribeFromTipjar();
      showSubscribtionModal();
    } catch (error) {
      console.log(log_error(error));
    } finally {
      setLoading(false);
    }
  };

  const subscriptionType = current_user.is_subscribed_to_primo
    ? "primo"
    : "tipjar";

  return (
    <Modal
      className="unsubscribe-primo-modal"
      show={show}
      onHide={hide}
      animation={true}
    >
      <Modal.Body className="text-center p-4 m-3">
        <p className="text-uppercase">
          {`are you sure you want to unsubscribe from ${subscriptionType}?😳`}
        </p>
        {current_user.is_subscribed_to_primo && (
          <small>Note: Doing so will delete all distributed tracks</small>
        )}

        <div className="d-flex justify-content-center mt-3">
          <button
            onClick={hide}
            type="reset"
            className="btn btn-outline-primary btn-md mr-3"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary btn-md"
            onClick={handleUnsubscribe}
          >
            {loading ? (
              <Spinner size="sm" animation="border" role="status" />
            ) : (
              "Yes"
            )}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
